[<template>
  <div>
    <canvas id="canvas" @mousedown="handleMouseDown" @mousemove="handleMouseMove"></canvas>
    <div v-show="false" ref="imageViewer" class="images" v-viewer="{navbar: false,toolbar: false}">
      <img :src="downloadImageHref" />
    </div>
    <div class="row">
      <div class="text-right pr-15">
        <a
          v-if="downloadImageHref"
          :href="downloadImageHref"
          download="download"
          class="download-link btn btn-default btn-outline rounded"
        >{{this.$t('app.sites.download')}}</a>
        <base-button
          :title="this.$t('app.sites.viewMode')"
          :classNames="`btn btn-default btn-outline rounded`"
          @clicked="showViewMode"
        />
      </div>
    </div>
    <div v-if="isTooltipVisible" :style="toolTipStyle" class="area-tooltip">{{areaName}}</div>
  </div>
</template>

<script>
import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'SiteLocation',
  components: {
    'base-button': BaseButton,
  },
  props: {
    locations: {
      type: Array,
      required: true,
    },
    imageUrl: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      downloadImageHref: undefined,
      canvas: undefined,
      ctx: undefined,
      mousedown: false,
      last_mousex: 0,
      last_mousey: 0,
      coordinates: [],
      percentCoordinates: [],
      dotCount: 0,
      isTooltipVisible: false,
      areaName: '',
      toolTipStyle: undefined,
      paths: [],
    };
  },
  created() {},
  mounted() {
    if (this.imageUrl) {
      this.drawBacgkroundImage(this.imageUrl, this.locations, this);
    }
  },
  methods: {
    inside(point, vs) {
      // ray-casting algorithm based on
      // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
      let x = point[0],
        y = point[1];

      let inside = false;
      for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        let xi = vs[i][0],
          yi = vs[i][1];
        let xj = vs[j][0],
          yj = vs[j][1];

        const intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    showViewMode() {
      const viewer = this.$refs.imageViewer.$viewer;
      viewer.show();
    },
    handleMouseMove(event) {
      let bb,
        x,
        y;
      const cnv = this.canvas;
      const ctx = this.ctx;
      bb = cnv.getBoundingClientRect();
      x = (event.clientX - bb.left) * (cnv.width / bb.width);
      y = (event.clientY - bb.top) * (cnv.height / bb.height);
      this.paths.forEach((path, index) => {
        if (!ctx.isPointInPath(path, x, y)) {
          this.isTooltipVisible = false;
        } else {
        }
      });
    },
    drawBacgkroundImage(url, locations, main) {
      const canvas = document.getElementById('canvas');
      this.canvas = canvas;
      const canvasx = canvas.offsetWidth;
      const canvasy = canvas.offsetHeight;

      this.canvas.width = canvasx;
      this.canvas.height = canvasy;
      canvas.width = canvasx;
      canvas.height = canvasy;

      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = url;
      const ctx = this.canvas.getContext('2d');
      this.ctx = ctx;
      image.onload = function () {
        const ratio = canvas.width / image.width;
        canvas.height = image.height * ratio;
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        if (locations && locations.length > 0) {
          locations.forEach((location) => {
            ctx.strokeStyle = location.web_area_color; // set style for line
            ctx.fillStyle = location.web_area_color; // set style for circle
            const area = location.area;
            const path = new Path2D();
            if (area && area !== null && area !== undefined) {
              ctx.beginPath();
              area.forEach((coordinate, index) => {
                if (index === 0 && area[index + 1] !== undefined) {
                  ctx.moveTo(
                    (area[index][0] / 100) * canvasx,
                    (area[index][1] / 100) * canvas.height,
                  ); // set start point for line
                  path.moveTo(
                    (area[index][0] / 100) * canvasx,
                    (area[index][1] / 100) * canvas.height,
                  ); // set start point for line
                } else if (area[index + 1] !== undefined) {
                  ctx.lineTo(
                    (area[index][0] / 100) * canvasx,
                    (area[index][1] / 100) * canvas.height,
                  ); // set end point for line
                  path.lineTo(
                    (area[index][0] / 100) * canvasx,
                    (area[index][1] / 100) * canvas.height,
                  ); // set end point for line
                  ctx.stroke();
                } else if (area.length > 1 && area[index + 1] === undefined) {
                  ctx.lineTo(
                    (area[index][0] / 100) * canvasx,
                    (area[index][1] / 100) * canvas.height,
                  ); // set end point for line
                  path.lineTo(
                    (area[index][0] / 100) * canvasx,
                    (area[index][1] / 100) * canvas.height,
                  ); // set end point for line
                  ctx.lineTo(
                    (area[0][0] / 100) * canvasx,
                    (area[0][1] / 100) * canvas.height,
                  ); // set start point for line
                  path.lineTo(
                    (area[0][0] / 100) * canvasx,
                    (area[0][1] / 100) * canvas.height,
                  ); // set start point for line
                  ctx.stroke();
                }
              });
              path.closePath();
              main.paths.push(path);
              ctx.closePath();
              ctx.fill();
            }
          });
        }
        canvas;
        main.downloadImageHref = canvas.toDataURL('image/png');
      };
    },
    handleMouseDown(event) {
      let bb,
        x,
        y;
      const cnv = this.canvas;
      const ctx = this.ctx;
      bb = cnv.getBoundingClientRect();
      x = (event.clientX - bb.left) * (cnv.width / bb.width);
      y = (event.clientY - bb.top) * (cnv.height / bb.height);
      this.paths.forEach((path, index) => {
        if (ctx.isPointInPath(path, x, y)) {
          this.isTooltipVisible = true;
          this.areaName = this.locations[index].name;
          this.toolTipStyle = {
            top: `${event.clientY}px`,
            left: `${event.clientX}px`,
          };
          // setTimeout(() => this.isTooltipVisible = false, 2000);
        }
      });
    },
    compare(a, b) {
      const distanceA = a.distance;
      const distanceB = b.distance;

      let comparison = 0;

      if (distanceA > distanceB) {
        comparison = 1;
      } else if (distanceA < distanceB) {
        comparison = -1;
      }
      return comparison;
    },
  },
  computed: {},
  watch: {
    imageUrl(newValue, oldvalue) {
      this.drawBacgkroundImage(newValue,this.locations,this);
    },
    area(newValue, oldvalue) {
      this.drawBacgkroundImage(this.imageUrl,this.locations,this);
    },
  },
};
</script>

<style lang="scss">
#canvas {
  width: 70% !important;

  @media (max-width: 1670px) {
    width: 586px;
  }
  width: 545px;
}
.area-tooltip {
  background-color: #adadad;
  padding: 5px 10px;
  font-size: 14px;
  position: fixed;
}

.download-link {
  width: 140px;
  cursor: pointer;
}
</style>
]



// WEBPACK FOOTER //
// src/components/modules/partners/SiteLocations.vue